import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import {
  BasicTable,
  CustomiseTabs,
  DottedText,
  Switch,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { observer } from 'mobx-react';
import BasicModal from '../../atoms/BasicModal';
import {
  getKpiRowsFromCohort,
  getKpiPopupColumns,
  transformCohortData,
  buildCohortCards,
} from '../../../core-utils/helper-utils/kpiPopupHelper';
import { TabItem } from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/CustomiseTabs';
import { SingleCardComponentProps } from '../../../pages/ExperiencePage';
import NoTabsData from '../../molecules/NoTabsData';
import Dicussion from '../../atoms/Icons/Dicussion';
import Business from '../../atoms/Icons/Business';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../atoms/Snackbar';
import { formatDate } from '../../../core-utils/helper-utils/helper';
import axios from 'axios';
import properties from '../../../core-utils/properties';
import Loader from '../../molecules/Loader';

import {
  CardComponent,
  CardComponentProps,
  ClaimsAnalysisProps,
  SingleCardComponent,
} from '../../molecules/KpiCards';
import { useNavigate } from 'react-router-dom';
import { useStores } from '../../../stores';
import { DEEP_DIVE } from '../../../core-utils/routes';

// ─── INTERFACES / PROPS

// ─── useStyles
const useStyles = makeStyles()({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  container1: {
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderRadius: '8px',
    height: '319px',
  },
  containerNoData: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FAFAFC',
  },
  container1Center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '315px',
    width: '825px',
    padding: '10px',
  },
  noDataBottomCardContainer: {
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderRadius: '8px',
    width: '100%',
    height: '160px',
    margin: '10px',
    backgroundColor: '#FAFAFC',
  },
  container2: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  defaultCard: {
    padding: '0px',
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    boxSizing: 'border-box',
    height: '106px',
    backgroundColor: '#fff',
  },
  borderItem: {
    borderRight: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    marginRight: '20px',
    height: '20px',
    alignSelf: 'center',
  },
  cardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: '12px 12px 18px 12px',
    height: '106px',
    boxSizing: 'border-box',
    gap: '18px',
  },
  simpleContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    // maxWidth: '264px',
    width: '100%',
    height: '150px',
    borderRadius: '8px',
    paddingTop: '8px',
    marginBottom: '12px',
    padding: '0px 2px',
  },
  kpiValueContainer: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '7px',
    width: '160px',
  },
  categoriesCardItem: {
    display: 'flex',
    padding: '8px 1px',
    gap: '4px',
    width: '100%',
  },
  categLabelSection: {
    display: 'flex',
    width: '80%',
    alignItems: 'center',
    gap: '4px',
  },
  loaderContainer: {
    height: '250px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cohortloaderContainer: {
    height: '160px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  topLeftRadius: {
    borderTopLeftRadius: '8px',
  },
  topRightRadius: {
    borderTopRightRadius: '8px',
  },
  bottomLeftRadius: {
    borderBottomLeftRadius: '8px',
  },
  bottomRightRadius: {
    borderBottomRightRadius: '8px',
  },
  noDataCard: {
    height: '120px',
    display: 'flex',
    justifyContent: 'center',
  },
  bottomCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 8px',
  },
  bottomCardTitle: {
    display: 'flex',
    gap: '3px',
    alignItems: 'center',
  },
  middleRowCard: {
    backgroundColor: '#F8F8FC',
  },
});

// ─── COMPONENTS

const ClaimsAnalysis: React.FC<ClaimsAnalysisProps> = observer(
  ({
    egnid,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
  }) => {
    const { classes } = useStyles();
    const navigate = useNavigate();
    const quarterlyReportStore = useStores().quaterlyReportStore;
    const [isDefaultKpiOpen, setIsDefaultKpiOpen] = useState<boolean>(false);
    const [tabs, setTabs] = useState<TabItem[]>([]);
    const abortController = new AbortController();

    const [snackbarState, setSnackbarState] = React.useState<{
      open: boolean;
      message: string;
      severity: MuiColor | undefined;
      duration: null | number;
    }>({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
    const [isKpiPopup, setIsKpiPopUp] = useState<boolean>(false);
    const [bottomCardData, setBottomCardData] = useState<
      SingleCardComponentProps[]
    >([]);
    const [rawCohortData, setRawCohortData] = useState<any[]>([]);
    const [cardData, setCardData] = useState<CardComponentProps[]>([]);
    const [selectedCohort, setSelectedCohort] = useState<any>(null);
    const [lastUpdatedDate, setLastUpdatedDate] = useState<string>('');
    const [analysis_duration, setAnalysis_duration] = useState<string>('');
    const [cohortLoading, setCohortLoading] = useState<boolean>(true);
    const [mainLoader] = useState<any>(<Loader height="400px" />);

    // Functions

    const handleOpenSnackBar = (
      message: string,
      severity: MuiColor,
      duration: number | null,
    ) => {
      setSnackbarState({
        open: true,
        message: message,
        severity: severity,
        duration: duration,
      });
    };
    const handleCloseSnackBar = (
      event?: React.SyntheticEvent,
      reason?: string,
    ) => {
      if (reason === 'clickaway') {
        return;
      }
      setSnackbarState({
        open: false,
        message: '',
        severity: undefined,
        duration: null,
      });
    };

    const handleNavigate = (
      key: any,
      value: any,
      reference_date?: any,
      title?: string,
    ) => {
      const endDate = new Date(reference_date);
      const formattedEndDate = endDate.toISOString().split('T')[0];
      const startDate = new Date(reference_date);
      title === 'Top Spending Categories'
        ? startDate.setUTCFullYear(startDate.getUTCFullYear() - 2)
        : startDate.setUTCFullYear(startDate.getUTCFullYear() - 3);
      startDate.setUTCDate(1);
      const formattedStartDate = startDate.toISOString().split('T')[0];
      quarterlyReportStore.setIsIncurredDate(false);
      quarterlyReportStore.setIsPaidDate(true);
      quarterlyReportStore.setPaidStartDate(
        formattedStartDate ?? quarterlyReportStore.minPaid,
      );
      quarterlyReportStore.setPaidEndDate(
        formattedEndDate ?? quarterlyReportStore.maxPaid,
      );
      navigate(DEEP_DIVE, { state: { key, value } });
    };

    const handleItemAction = (id: string, actionType: string, value?: any) => {
      if (actionType === 'toggle-visibility') {
        setTabs((prevTabs) => {
          const currentTab = prevTabs.find((tab) => tab.id === id);
          const currentlyVisibleCount = prevTabs.filter((tab) => tab.visible)
            .length;
          if (!currentTab?.visible && currentlyVisibleCount >= 9) {
            handleOpenSnackBar(
              'You can select up to 9 KPIs only.',
              'info',
              3000,
            );
            return prevTabs;
          }

          // Always allow disabling or enabling if count < 9
          const updatedTabs = prevTabs.map((tab) =>
            tab.id === id ? { ...tab, visible: value } : tab,
          );
          return updatedTabs;
        });
      }
      if (actionType === 'reorder' && Array.isArray(value)) {
        setTabs(value);
      }
    };

    const renderVisibilityControl = (tab: any, onAction: any) => (
      <Switch
        checked={tab.visible}
        color="primary"
        handleChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onAction('toggle-visibility', e.target.checked)
        }
      />
    );

    const handleSaveKpi = async (egnid: string, updatedTabs: TabItem[]) => {
      try {
        const payload = {
          eg_nid: egnid,
          updatedKpis: updatedTabs.map((tab, index) => ({
            label: tab.label,
            visible: tab.visible,
            index,
          })),
        };

        await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.updateDefaultClaimsKpis,
          payload,
        );
        handleOpenSnackBar(
          'Default kpi tab updated successfully',
          'success',
          3000,
        );
        await getDefaultKpi();
      } catch (error) {
        handleOpenSnackBar('Failed to update the default kpi', 'error', 5000);
      }
    };

    const handleSave = async () => {
      const selectedCount = tabs.filter((tab) => tab.visible).length;
      if (selectedCount !== 9) {
        handleOpenSnackBar(
          'You must select exactly 9 KPIs before saving.',
          'info',
          3000,
        );
        return;
      }
      await handleSaveKpi(egnid, tabs);
      setIsDefaultKpiOpen(false);
    };

    const getTopCohortAnalysis = async () => {
      try {
        const resp = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getCohortAnalysis,
          {
            startDate: paidStartDate,
            endDate: paidEndDate,
            eg_nid: egnid,
          },
          { signal: abortController.signal },
        );
        let rawData = resp.data.data;
        // Normalize rawData so result is always an array
        rawData = rawData?.map((entry: any) => ({
          ...entry,
          result: Array.isArray(entry?.result) ? entry?.result : [],
        }));
        setRawCohortData(rawData);
        const transformed = transformCohortData(rawData);
        const full = buildCohortCards(
          transformed,
          rawData,
          setIsKpiPopUp,
          setSelectedCohort,
          handleNavigate,
        );
        setBottomCardData(full);
      } catch (err) {
        console.error('Error in get top chort', err);
      }
    };

    const getDefaultKpi = async () => {
      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getDefaultClaimsKpi,
          { eg_nid: egnid },
          { signal: abortController.signal },
        );
        const transformed = response?.data?.kpis?.map((item: any) => ({
          title: item?.display_name,
          membersPer: item?.value,
          populationPer: item?.benchmark,
          index: item?.index,
          visible: item?.visible,
          kpiUnit: item?.value_entity,
          toolTipData: item?.display_name_tooltip,
          redirecting: item?.redirection,
        }));
        setLastUpdatedDate(response?.data?.updatedAt);
        setAnalysis_duration(response?.data?.analysis_duration);
        setCardData(transformed);
      } catch (err) {
        console.error('Error in default kpi');
      }
    };

    const fetchClaimsData = async () => {
      setCohortLoading(true);
      try {
        await Promise.allSettled([getTopCohortAnalysis(), getDefaultKpi()]);
      } catch (error) {
        console.error();
      } finally {
        setCohortLoading(false);
      }
    };

    // useEffect

    useEffect(() => {
      const allDatesPresent =
        incurredStartDate && incurredEndDate && paidStartDate && paidEndDate;

      if (!allDatesPresent) {
        setCohortLoading(false);
        return;
      }

      fetchClaimsData();
    }, [
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      aggregationParameter,
    ]);

    useEffect(() => {
      const defaultTabs: TabItem[] = [...cardData]
        .sort((a, b) => a.index - b.index)
        .map((card, idx) => ({
          id: `${idx}`,
          label: card.title,
          visible: card.visible,
          index: card.index,
        }));
      setTabs(defaultTabs);
    }, [cardData]);

    return cohortLoading ? (
      mainLoader
    ) : (
      <Grid className={classes.mainContainer}>
        <Grid container spacing={2}>
          {bottomCardData?.every(
            (card) => !card.items || card.items.length === 0,
          ) ? (
            <Grid className={classes.noDataBottomCardContainer}>
              <NoTabsData icon={<Dicussion />} label="No Data Found !" />
            </Grid>
          ) : (
            bottomCardData?.map((card: any, idx: any) => (
              <Grid
                key={idx}
                size={{
                  sm: 4,
                }}
              >
                <SingleCardComponent
                  title={card.title}
                  subTitle={card.subTitle}
                  items={card.items}
                  backgroundColor={card.backgroundColor}
                  borderColor={card.borderColor}
                  rawCohortData={rawCohortData}
                  setIsKpiPopUp={setIsKpiPopUp}
                  aggregatedColumn1Header={card.aggregatedColumn1Header}
                  aggregatedColumn1Value={card.aggregatedColumn1Value}
                  aggregatedColumn2Header={card.aggregatedColumn2Header}
                  aggregatedColumn2Value={card.aggregatedColumn2Value}
                  onArrowClick={(matched: any) =>
                    setSelectedCohort({
                      ...matched,
                      title: card?.title,
                      subTitle: card?.subTitle,
                    })
                  }
                  handleNavigate={handleNavigate}
                />
              </Grid>
            ))
          )}
        </Grid>
        <Grid
          className={`${classes.container1} ${
            cardData.length === 0 ? classes.containerNoData : ''
          }`}
          container
        >
          {cardData?.length === 0 ? (
            <Grid className={classes.container1Center}>
              <NoTabsData icon={<Business />} label="No Data Found !" />
            </Grid>
          ) : (
            cardData
              .filter((card) => card.visible)
              .sort((a, b) => a.index - b.index)
              .slice(0, 9)
              .map(
                (
                  {
                    title,
                    membersPer,
                    populationPer,
                    index,
                    visible,
                    kpiUnit,
                    toolTipData,
                    redirecting,
                  },
                  idx,
                ) => {
                  const total = cardData.length;
                  const isFirst = idx === 0;
                  const isLast = idx === total - 1;
                  const isTopLeft = isFirst;
                  const isTopRight = total === 1 || idx === 2;
                  const isBottomLeft = total > 3 && idx === total - 3;
                  const isBottomRight = isLast;
                  const isMiddleRow = idx >= 3 && idx <= 5;
                  const cardClass = [
                    classes.defaultCard,
                    isTopLeft ? classes.topLeftRadius : '',
                    isTopRight ? classes.topRightRadius : '',
                    isBottomLeft ? classes.bottomLeftRadius : '',
                    isBottomRight ? classes.bottomRightRadius : '',
                    isMiddleRow ? classes.middleRowCard : '',
                  ]
                    .filter(Boolean)
                    .join(' ');

                  return (
                    <Grid
                      key={idx}
                      className={cardClass}
                      size={{
                        xs: 12,
                        sm: 6,
                        md: 4,
                      }}
                    >
                      <CardComponent
                        title={title}
                        membersPer={membersPer}
                        populationPer={populationPer}
                        index={index}
                        visible={visible}
                        kpiUnit={kpiUnit}
                        toolTipData={toolTipData}
                        redirecting={redirecting}
                      />
                    </Grid>
                  );
                },
              )
          )}
        </Grid>
        {cardData?.length > 0 ? (
          <Grid className={classes.container2}>
            <Typography
              fontSize="12px"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              Above data corresponds to claims feed up to{' '}
              {formatDate(lastUpdatedDate, 'DD MMM, YYYY')}{' '}
              {analysis_duration && `(${analysis_duration})`}
            </Typography>
            <span
              onClick={() => {
                setIsDefaultKpiOpen(true);
              }}
            >
              <DottedText
                typographyStyles={{ fontSize: '12px' }}
                text="Edit KPIs"
              />
            </span>
          </Grid>
        ) : (
          ''
        )}
        {isKpiPopup && (
          <BasicModal
            open={isKpiPopup}
            width="1092px"
            height="500px"
            handleClose={() => {
              setIsKpiPopUp(false);
            }}
            title={selectedCohort?.title}
            isSaveButton={false}
            isCloseBtn={false}
            saveBtnAction={() => {}}
            isScrollable={true}
          >
            <BasicTable
              width="1000px"
              tableBodyStyles={{
                border: 'none',
              }}
              cellPadding="0px"
              columns={getKpiPopupColumns(
                selectedCohort?.subTitle,
                selectedCohort?.result?.[0]?.aggregated_data,
                selectedCohort?.aggregated_cost_column_1_header,
                selectedCohort?.aggregated_cost_column_2_header,
              )}
              rowsData={
                selectedCohort?.result?.length !== 0
                  ? getKpiRowsFromCohort(
                      selectedCohort?.title,
                      selectedCohort?.result,
                      handleNavigate,
                      selectedCohort?.reference_date,
                    )
                  : []
              }
            />
          </BasicModal>
        )}
        <BasicModal
          open={isDefaultKpiOpen}
          height="530px"
          width="600px"
          handleClose={() => {
            setIsDefaultKpiOpen(false);
          }}
          title={'Customize KPIs'}
          saveBtnText="Apply KPIs"
          isSaveButton={true}
          isCloseBtn={true}
          saveBtnAction={handleSave}
          isScrollable={true}
        >
          <CustomiseTabs
            open={true}
            width="700px"
            height="100%"
            title1="Selected Columns"
            title2="Drag to reorder"
            tabs={tabs}
            setTabs={setTabs}
            onItemAction={handleItemAction}
            renderItemAction={renderVisibilityControl}
          />
        </BasicModal>
        <Snackbar
          {...snackbarState}
          handleClose={handleCloseSnackBar}
          vertical="bottom"
          horizontal="right"
        />
      </Grid>
    );
  },
);

export default ClaimsAnalysis;
